import React, { Component } from 'react'
import '../DriverDetailNew.css'
import './DocumentTab.css'
import DocumentListContainer from "../../../../../Material/DocumentModal/DocumentListContainer"
import RentalDocumentsTab from "./RentalDocumentsTab"

const DOCUMENT_SUBNAV_ITEMS = [
    { id: "driver", label: "Driver Documents", icon: "fa-id-card-o" },
    { id: "rental", label: "Rental Documents", icon: "fa-file-text-o" },
]

class DocumentsTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: "driver",
        }
    }
    render() {
        return (
            <div className="documents-tab">
                <div className="document-module-header">
                    <div className="document-module-subnav">
                        {DOCUMENT_SUBNAV_ITEMS.map(item => (
                            <button key={item.id} type="button" className={`document-module-subnav__btn ${this.state.activeTab === item.id ? "is-active" : ""}`} onClick={() => this.setState({ activeTab: item.id })} >
                                <i className={`fa ${item.icon}`} aria-hidden="true" /><span>{item.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
                {this.state.activeTab === "driver" &&
                    <div className="document-section-panel">
                        <DocumentListContainer
                            colSize={"4"}
                            id={this.props.id}
                            objectType={"driver"}
                            currentUser={this.props.currentUser}
                        />
                    </div>
                }
                {this.state.activeTab === "rental" &&
                    <div className="document-section-panel">
                        <RentalDocumentsTab
                            driverId={this.props.id}
                            currentUser={this.props.currentUser}
                        />
                    </div>
                }
            </div>
        )
    }
}

export default (DocumentsTab)
